export const MOBEES_FORM_SUCCESS_MESSAGE = "Your campaign has been successfully requested! Now just wait for Mobees' approval.";
export const MOBEES_FORM_ERROR_MESSAGE = 'Something went wrong with our service. Please, try again in a few minutes.';
